import React, { useState } from 'react'
import './stickybutton.css'
import { notification } from 'antd';
import { executeIntent } from '../../../experience/utils/IntentExecutor';
import IntentType from '../../../intentexecutor/utils/IntentType';
import ModalPublicFormRendererComponent from '../../../experience/generic/forms/ModalPublicFormRendererComponent';

const StickyButton = () => {
  const [openDemoRequestModal, setOpenDemoRequestModal] = useState(false);
    const [formTemplateData, setFormTemplateData] = useState({});
  
    const onDataSubmitCallback = () => {
      setOpenDemoRequestModal(false);
      notification.success({
        message:
          "Thank you for requesting a demo! Our team will get in touch with you shortly.",
        placement: "bottomRight",
      });
    };
  
    const openScheduleADemo = async () => {
      try {
        const payload = {
          configurationKey: ["niramaya.publicform.scheduleademo"],
        };
        const response = await executeIntent(
          IntentType.GET_PUBLIC_CONFIGURATION,
          payload
        );
        if (response[0].configurationValue) {
          setFormTemplateData(JSON.parse(response[0].configurationValue));
          setOpenDemoRequestModal(true);
        }
      } catch (err) {
        notification.error({
          message: "Error while getting form",
          placement: "bottomRight",
        });
      }
    };
  

  return (
    <div className="schedule-demo-wrapper">
      <button className="schedule-demo-btn" onClick={openScheduleADemo}>
        Schedule a Demo
      </button>
            {openDemoRequestModal && (
              <ModalPublicFormRendererComponent
                formTitle="Schedule a Demo"
                formTemplateData={formTemplateData}
                isModalOpen={openDemoRequestModal}
                footer={null}
                formSubmitCallback={onDataSubmitCallback}
                setIsModalOpen={setOpenDemoRequestModal}
              />
            )}
    </div>

  )
}

export default StickyButton
